import {Container} from "./Container"

export const ReportsStyles = {
    Container
}